import { DatabricksDashboard } from '@databricks/aibi-client';
import { Injectable } from '@angular/core';
import { EmbeddedDashboardHandle, EmbeddedDashboardOptions } from 'app/shared/models/dashboard-embed.model';

/**
 * The one place `new DatabricksDashboard(...)` is written, for two reasons.
 *
 * It keeps the component testable: the real constructor creates an iframe, registers a `window` message
 * listener and starts a refresh timer, none of which a spec wants, so the component is tested against a
 * fake. And it is the only point where the library's iframe exists but has not navigated yet, which is
 * when it must be made `credentialless` — do not inline the constructor back into the component.
 */
@Injectable({
  providedIn: 'root'
})
export class DatabricksDashboardFactory {
  create(options: EmbeddedDashboardOptions): EmbeddedDashboardHandle {
    const dashboard = new DatabricksDashboard(options);
    this.makeFrameCredentialless(dashboard);
    return dashboard;
  }

  // `iframe` is private only to TypeScript; the factory spec runs the real library to catch a rename.
  private makeFrameCredentialless(dashboard: DatabricksDashboard): void {
    const frame = (dashboard as unknown as { iframe?: unknown }).iframe;

    if (!(frame instanceof HTMLIFrameElement)) {
      console.warn('[DatabricksDashboardFactory] The library no longer exposes its iframe — the embed is not credentialless and COEP will block it.');
      return;
    }

    frame.setAttribute('credentialless', '');
  }
}
